/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Latest_TitleInputs */

const en_directory_launch_latest_title = /** @type {(inputs: Directory_Launch_Latest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Discoveries`)
};

const zh_directory_launch_latest_title = /** @type {(inputs: Directory_Launch_Latest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新发现`)
};

/**
* | output |
* | --- |
* | "Latest Discoveries" |
*
* @param {Directory_Launch_Latest_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_latest_title = /** @type {((inputs?: Directory_Launch_Latest_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Latest_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_latest_title(inputs)
	return zh_directory_launch_latest_title(inputs)
});
export { directory_launch_latest_title as "directory.launch.latest_title" }